import React from 'react';
import { NavLink } from 'react-router-dom';
import useAuth from '../../auth/useAuth';
import SectionNavigation from '../../components/SectionNavigation';

const MaterialHeader = () => {
  const { user } = useAuth();

  return (
    <SectionNavigation ariaLabel="Materials navigation">
      <NavLink to="/materials/listofmaterials">List of materials</NavLink>
      <NavLink to="/materials/hardnesscomparison">Hardness comparison</NavLink>
      <NavLink to="/materials/materialfinder">Material Finder</NavLink>
      <NavLink to="/materials/materialcomparison">Material Comparison</NavLink>
      <NavLink to="/materials/requests">Request Material</NavLink>
      {user?.role === 'admin' && (
        <>
          <NavLink to="/materials/materialform">Material Form</NavLink>
          <NavLink to="/materials/trash">Trash</NavLink>
        </>
      )}
    </SectionNavigation>
  );
};

export default MaterialHeader;
